import { render } from "./FormSyscom.vue?vue&type=template&id=0d174310"
import script from "./FormSyscom.vue?vue&type=script&lang=js"
export * from "./FormSyscom.vue?vue&type=script&lang=js"

import "./FormSyscom.vue?vue&type=style&index=0&id=0d174310&lang=css"
script.render = render

export default script